import { render, staticRenderFns } from "./industryGuru.vue?vue&type=template&id=80faf2da&scoped=true"
import script from "./industryGuru.vue?vue&type=script&lang=js"
export * from "./industryGuru.vue?vue&type=script&lang=js"
import style0 from "./industryGuru.vue?vue&type=style&index=0&id=80faf2da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80faf2da",
  null
  
)

export default component.exports